import { SettingsApplications } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useOAuth } from '@novafuturltd/core'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { OrgIdTypeEnum } from '../../../../containers/Sidebar/trading/types'
import parseOrgId from '../../../../helpers/parseOrgId/parseOrgId'

interface MenuMiniGamesProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuMiniGames = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuMiniGamesProps) => {
  const { formatMessage } = useIntl()
  const { organizationId: orgId } = useOAuth()

  const isSelected = pathname.startsWith('/casino/mini-games')

  if (parseOrgId(orgId) !== OrgIdTypeEnum.BET9JA) {
    return null
  }

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/casino/mini-games"
        selected={isSelected}
      >
        <ListItemIcon>
          <SettingsApplications />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.mini_games.title',
          })}
        />
      </MenuItem>
    </div>
  )
}
